import { CustomGroup } from '../../shared/types/customGroup';
import { Sso } from '@common/types/common';

export const isEditable = (sso: Sso, group: CustomGroup) => {
  if (!group) {
    return false;
  }

  const isEditable = group.publicFlag && group.allowEditFlag;
  return sso === group.ownerSso || isEditable;
};

export const isGroupOwner = (sso: Sso, group: CustomGroup) => sso === group.ownerSso;
